import cookies from "js-cookie";
import { FAMILY_MODE_STORAGE_KEY } from "constants/index";

export const clearSession = () => {
  cookies.remove("steezy_sid");
  sessionStorage.removeItem("tt_sessionId");
  localStorage.removeItem(FAMILY_MODE_STORAGE_KEY);
};
